import { render, staticRenderFns } from "./AddSeafarerWithoutPersonalCode.vue?vue&type=template&id=fb87f152"
import script from "./AddSeafarerWithoutPersonalCode.vue?vue&type=script&lang=ts"
export * from "./AddSeafarerWithoutPersonalCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports